<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <extra-list
        v-bind:extras="extraList"
        v-on:addExtra="addExtra"
        v-on:viewExtra="viewExtra"
        v-on:deleteExtra="deleteExtra"
      ></extra-list>
    </div>
    <div class="md-layout-item md-size-50">
      <extra-edit
        v-bind:extra="selectedExtra"
        v-on:extraUpdated="extraUpdated"
      ></extra-edit>
    </div>
  </div>
</template>

<script>
import extraApi from "@/services/api/extra";
import confirm from "@/helpers/deleteConfirm";

import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";

import Swal from "sweetalert2";

import ExtraList from "./ExtraList";
import ExtraEdit from "./ExtraEdit";

export default {
  components: {
    ExtraList,
    ExtraEdit
  },

  data() {
    return {
      selectedExtra: null,
      extraList: []
    };
  },

  methods: {
    getExtras() {
      extraApi.getAll().then(response => {
        this.extraList = response.data;
      });
    },

    addExtra() {
      this.selectedExtra = {
        prices: {},
        options: []
      };
    },

    viewExtra(extra) {
      this.selectedExtra = { ...extra };
    },

    deleteExtra(extra) {
      confirm.delete().then(resp => {
        if (resp.value) {
          extraApi.delete(extra.id).then(response => {
            this.extraList = _filter(this.extraList, function(item) {
              return item.id !== extra.id;
            });

            this.$notify({
              timeout: 2500,
              message: "Deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });

            this.selectedExtra = null;
          });
        }
      });
    },

    extraUpdated(updateInfo) {
      if (updateInfo.mode == "CREATE") {
        this.extraList.unshift(updateInfo.extra);
      } else {
        var index = _findIndex(this.extraList, {
          id: updateInfo.extra.id
        });
        this.extraList.splice(index, 1, updateInfo.extra);
      }

      this.selectedExtra = updateInfo.extra;
    }
  },

  mounted() {
    this.getExtras();
  }
};
</script>
